import {ControlButton, ControlButtonType, themeNames, TscStyles} from '@techsmith/tsc-cloud-style-guide';
import React from 'react';
import styled from 'styled-components';
import cssConstants from '../../constants/cssConstants';
import withMemoizedContexts from '../../context/contextContainerHoC';
import {themeStore} from '../../context/themeProvider';
import {ScreenReaderOnly} from './StyledElements';

const AccessibilityContainer = styled.div<{theme: themeNames}>`
   margin: 0 auto 8px auto;
   border-radius: 0 0 0.125rem 0.125rem;
   box-shadow: ${props => props.theme === themeNames.dusk ?
      `0 0 0.25rem 0 fade(${TscStyles.color.action.primary}, 90%)` :
      `0 0.1875rem 0.25rem 0 fade(${TscStyles.color.ui.dusk.dark}, 20%), 0 0.1875rem 0.1875rem -0.125rem fade(${TscStyles.color.ui.dusk.dark}, 15%)`};
   padding: 0.25rem 0.25rem;
   overflow: hidden;
   background-color: ${props => props.theme === themeNames.dusk ? TscStyles.color.ui.dusk.medium : TscStyles.color.ui.dawn.light};
   z-index: 0;
   position: absolute;
   left: -9999px;
   align-self: center;

   &:focus-within {
      z-index: ${cssConstants.zIndex.skipToContentPopUp};
      left: unset;
   }
`;

const BypassBlockContainer = styled.div`
   display: flex;

   a {
      z-index: 0;

      &:focus {
         position: relative;
         z-index: ${cssConstants.zIndex.skipToContentPopUp};
         margin: 0.5rem;
      }
   }
`;

const SkipLink: React.FC<ISkipLinkProps & IStateMappedProps> = ({href, text, theme}) => (
   <AccessibilityContainer theme={theme}>
      <BypassBlockContainer>
         <ControlButton buttonType={ControlButtonType.primary} href={href} label={text} />
      </BypassBlockContainer>
      <ScreenReaderOnly id="aria-live-status" role="status" aria-live="polite" />
   </AccessibilityContainer>
);

interface ISkipLinkProps {
   href: string;
   text: string;
}

interface IStateMappedProps {
   theme: themeNames;
}

const mapStatesToProps = (
   {href, text}: ISkipLinkProps,
   {theme}: Partial<IStateMappedProps>
): ISkipLinkProps & IStateMappedProps => ({href, text, theme});

export default withMemoizedContexts(mapStatesToProps, themeStore)(SkipLink);
